<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 10:52:25
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 16:19:37
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\step01 copy 5.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='step-box'>
        <div class="step-content">
            <div class="step-title">请至少选择一个您要注册的APP：</div>
        </div>
        <div class="product-box">
            <div v-for="(item, index) in productList" :key="index">
                <Product :value="item.enable" :logo="item.productIcon" :name="item.productName"
                    :registerId="item.registerId" :identifying="item.productCode" :isRegistered="item.usable"
                    :snCode="item.sn" @onBlur="onBlu" @changeSelect="changeSelect" @getBarCcode="getBarCcode"
                    @showAgreement="showAgreement" />
            </div>
        </div>
        <div class="bom-tips">
            所有预绑定终端，若商户进件失败，会自动取消绑定。
        </div>

        <Footer @giveup="giveup" @confirm="confirm" @back="goProstep" :step="4" />
    </div>
</template>

<script>
import Product from "./product.vue"
import Footer from "./footer.vue"
import Agreement  from "./agreement.vue"
import { productList, bindingTermPreCheck, merchProduct, getWxConfig } from "@/api/index"
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'
export default {
    name: 'Step05',
    components: {
        Product,
        Footer,
        Agreement
    },
    data() {
        return {
            checked: false,
            productList: [],
        };
    },
    mounted() {
        let purl = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.localStorage.getItem('scanUrl');
        getWxConfig(purl).then(res => {
            // this.res = res
            this.$nextTick(() => {
                this.configInfo(res.data)
            })
        })
    },
    created() {
        this.$nextTick(() => {
            productList({ registerId: this.$store.state.merchartInfo.id }).then(res => {
                this.productList = res.data
                this.productList.map(item => {
                    item.sn ? item.enable = 1 : ""
                })
            })
        })
    },
    methods: {
        // 通过wx.config注入配置信息
        configInfo(res) {
            // alert(`"configInfo", ${wx}`)
            wx.config({
                appId: res.appId, // 必填，公众号的唯一标识
                signature: res.signature,// 必填，签名
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonce, // 必填，生成签名的随机串
                jsApiList: ['checkJsApi', 'scanQRCode'],
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                // 必填，需要使用的JS接口列表
            });
            // 处理成功后回调
            wx.ready(function () {
                // console.log("处理成功:");
            });
            // 处理失败后回调
            wx.error(function (err) {
                // console.log("处理失败:", err);
            });
        },
        onBlu(val) {
            this.productList.map(item => {
                item.productCode == val.type ? item.sn = val.sn : ''
            })
        },
        changeSelect(val) {
            this.productList.map(item => {
                item.productCode == val.identifying ? item.enable = val.status : ''
            })
        },
        // 条形码识别
        getBarCcode(val) {
            this.productList.map(item => {
                item.productCode == val.identifying ? item.sn = val.code : ''
            })

            Toast.clear()
        },

        // 显示协议
        showAgreement() {
            this.$emit("showAgreement")
        },

        // 上一步
        goProstep() {
            this.$emit("goProstep", { step: 4 })
        },

        // 下一步
        async confirm() {
            // 是否有选中的 产品
            const params = this.productList.filter(item => item.enable == 1)
            // console.log("选中的产品", params);
            if (params.length == 0) {
                Toast("请至少选择一个您要注册的APP")
                return
            }
            // 判断 选中的的 产品是否有 sn编码 幸福刷不需要sn
            const snCode = params.filter(item => item.productCode != "XFS" && (item.sn == "" || item.sn == null))
            if (snCode.length > 0) {
                Toast("请输入产品对应的终端号")
                return
            }

            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: "toast"
            });

            // 验证机具
            const taskID = this.$store.state.merchartInfo.taskId
            for (let i = 0; i < params.length; i++) {
                // 幸福刷不需要机具验证
                if (params[i].productCode == "XFS") {
                    continue
                }
                // 验证机具
                const obj = {
                    merchType: params[i].productCode,
                    sn: params[i].sn,
                    taskId: taskID
                }
                try {
                    const res = await bindingTermPreCheck(obj, this.$store.state.referKey)
                    console.log("res", res);
                    if (res.code != 200) {
                        Toast(params[i].productName + res.msg)
                        return
                    }
                } catch (error) {
                    params[i].sn = ""
                    Toast('接口请求失败，请重试')
                }
            }

            // 提交接口 
            const list = params.map(item => {
                return {
                    enable: item.enable,
                    id: item.id,
                    productName: item.productName,
                    productCode: item.productCode,
                    sn: item.sn || "",
                }
            })

            const data = {
                registerId: this.$store.state.merchartInfo.id,
                productDetails: list
            }
            console.log("---", data);
            const res = await merchProduct(data)
            console.log("提交接口  ", res);
            if (res.code != 200) {
                Toast(res.msg)
                return
            }
            // 提交注册产品信息 并判断 返回接口的 res.data.liveOrderH5Url ，如果不为空就需要进行人脸认证 否则就提交成功
            if (![null, undefined, ''].includes(res.data.liveOrderH5Url)) {
                window.open(res.data.liveOrderH5Url, "_self");
                Toast.clear()
                return
            }

            this.$emit("confirm", { data: res.data, step: 4 })

        },

        // 放弃注册
        giveup() {
            this.$emit("giveup")
        }
    },
};
</script>

<style scoped lang="scss">
.step-box {
    height: 100%;
    background-color: #fff;
    overflow: scroll;
}

.product-box {
    padding: 10px 15px;
    padding-bottom: 50px;
    background-color: #fff;
    overflow: scroll;
}

.bom-tips {
    padding: 10px 15px;
    font-size: 12px;
    color: #333333;
    background-color: #fff;
}
</style>